import React from 'react';
import './Consulting.css';

const SERVICES = [
  {
    num: '01',
    title: 'Cloud infrastructure and migration',
    desc: 'Architecture reviews, cost reduction and moving workloads to AWS, Azure or GCP.',
  },
  {
    num: '02',
    title: 'CI/CD and GitOps pipelines',
    desc: 'Full pipeline automation using ArgoCD, Bitbucket, CodePipeline and Helm.',
  },
  {
    num: '03',
    title: 'Observability stack',
    desc: 'Prometheus, Grafana, Loki and Tempo setup with proper alerting and SLO definitions.',
  },
  {
    num: '04',
    title: 'Kubernetes and containers',
    desc: 'Deploying and hardening workloads on EKS, GKE and Docker with Helm.',
  },
  {
    num: '05',
    title: 'Zero Trust and security',
    desc: 'Zscaler, IAM, Secrets Manager and Microsoft Defender wired into your stack.',
  },
  {
    num: '06',
    title: 'AI and LLM infrastructure',
    desc: 'Getting Vertex AI and Azure OpenAI running in production with proper scaling and monitoring.',
  },
];

function Consulting() {
  return (
    <section id="consulting" className="spine-layout consulting-bg">
      <div className="spine-col">
        <span>Consulting</span>
      </div>
      <div className="section-inner">
        <div className="sec-head">
          <h2 className="sec-title">Consulting services</h2>
          <span className="sec-num">02 / 03</span>
        </div>
        <p className="consulting-intro">
          I take on focused engagements where I can make a real difference.
          If your team needs senior DevOps experience without a full-time hire, let's talk.
        </p>
        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <div key={i} className="service-card">
              <div className="service-num">{s.num}</div>
              <h3 className="service-title">{s.title}</h3>
              <p className="service-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Consulting;
